import { createAsyncThunk } from "@reduxjs/toolkit";
import { IEmployeeProfilePhotoResponse } from "models/Employee/employeeProfile.model";
import { ITokenModel } from "models/Login/token.model";

import { EmployeeProfilePhoto } from "services/employeeProfile.service";

//employee profile photo
export const employeePhotoAsync = createAsyncThunk(
  "EmployeePhoto",
  async (empParams: ITokenModel): Promise<IEmployeeProfilePhotoResponse> => {
    try {
      const response = await EmployeeProfilePhoto(empParams);
      return response;
    } catch (error: any) {
      throw error;
    }
  }
);
